var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
const dsn = 'https://65ef11089e0441ceba8bcf87de2e58a0@o181208.ingest.sentry.io/6145432';
// Sentry SDK ネイティブの ignoreErrors で無視するエラー。
// message だけでなく exception の value/type にもマッチするため、
// 例外型で報告されるエラー（onerror 経由の SyntaxError 等）も確実にブロックできる。
// 主に JS チャンク読み込み失敗（サーバーが index.html を返す）でブラウザが
// HTML を JS としてパースして発生する SyntaxError。ソースコード起因ではないため通知不要。
const ignoreErrors = [
    /Unexpected token '<'/i, // Chrome / Safari
    /expected expression, got '<'/i, // Firefox
];
// Sentryで無視するエラーメッセージ
const ignoredErrorMessagesRegExp = [
    /ResizeObserver loop/i,
    /database unavailable/i,
    /NotAllowedError: play\(\) failed because/i,
    /AbortError: The play\(\) request was interrupted/i,
    /AbortError: The operation was aborted/i,
    /NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission/i,
    /null is not an object \(evaluating 'planElement.innerText'\)/i,
    /Cannot read properties of null \(reading 'innerText'\)/i,
];
const loadSentry = (config) => __awaiter(void 0, void 0, void 0, function* () {
    const Sentry = yield import('@sentry/react');
    const environment = config.isProduction ? 'production' : 'development';
    Sentry.init({
        dsn: dsn,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        environment: environment,
        ignoreErrors: ignoreErrors,
        denyUrls: [/^https:\/\/tracking\.sitest\.jp/i],
        beforeSend(event, hint) {
            const originalErr = hint === null || hint === void 0 ? void 0 : hint.originalException;
            const hasIgnoreOriginalErr = originalErr === null || originalErr === void 0 ? void 0 : originalErr.isUnauthorizedError;
            const hasIgnoreMessage = event && event.message && ignoredErrorMessagesRegExp.some((regexp) => regexp.test(event.message));
            if (hasIgnoreMessage || hasIgnoreOriginalErr)
                return null;
            return event;
        },
    });
});
export const LoadSentry = (config) => {
    void loadSentry(config).catch((error) => {
        console.error('Failed to initialize Sentry:', error);
    });
};
